@if (isMenu) {
  <button mat-menu-item aria-label="meta">
    <mat-icon>info_outline</mat-icon>
    {{ 'meta' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'meta' | translate"
    matTooltip="{{ 'meta' | translate }}">
    <mat-icon>info_outline</mat-icon>
  </button>
}
